module.exports = __webpack_public_path__ + "media/share.72965f11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/outSide/assets/img/share.svg
// module id = ./src/templates/outSide/assets/img/share.svg
// module chunks = 0